@if (energyInterfaceState()?.isLoading) {
  <app-edit-form-skeleton />
  <ui-skeleton class="block h-8 w-[174px] rounded-md mt-6" />
} @else if (!energyInterfaceState() || energyInterfaceState()?.error) {
  <ui-alert color="error">
    <ng-icon name="heroXCircle" size="20" slot="icon" class="!block" />
    {{ 'cockpit.energyInterfaces.details.general.errorLoadingEnergyInterface' | transloco }}
  </ui-alert>
} @else if (energyInterfaceState()?.data) {
  @if (energyInterfaceState()?.data; as energyInterface) {
    <app-energy-interface-details-edit-form
      [energyInterface]="energyInterface"
      [energyInterfaceId]="energyInterfaceId()"
      [organizationId]="organizationId()"
    />
    <div class="mt-6">
      <ui-button
        mode="outlined"
        size="small"
        type="button"
        data-track="cockpit-energy-interface-delete-button"
        (click)="onClickDelete()"
        [loading]="isDeleteLoading()"
      >
        <div slot="start" class="text-error dark:text-error-darkmode">
          <ng-icon name="heroTrash" size="20" class="!block" />
        </div>
        <div class="text-error dark:text-error-darkmode">
          {{ 'cockpit.energyInterfaces.details.general.deleteButton' | transloco }}
        </div>
      </ui-button>
    </div>
  }
}
